export default {
  clients: {
    title:
      'Una empresa sólida, con una larga trayectoria y una amplia experiencia con empresas referencia del mercado de diversos segmentos.',
  },
}
